import z from 'zod';

export const RoundingErrorDtoScheme = z.object({
	early_arrival_deviation: z.number().describe('Отклонение на приход раньше'),
	late_departure_deviation: z.number().describe('Отклонение на уход позже'),
	early_arrival_rounding: z.number().describe('Округление на приход'),
	late_departure_rounding: z.number().describe('Округление на уход'),
});

export type RoundingErrorDto = z.infer<typeof RoundingErrorDtoScheme>;
